import { render, staticRenderFns } from "./AtomCheckBox.vue?vue&type=template&id=08cda4fc&scoped=true&"
import script from "./AtomCheckBox.vue?vue&type=script&lang=ts&"
export * from "./AtomCheckBox.vue?vue&type=script&lang=ts&"
import style0 from "./AtomCheckBox.vue?vue&type=style&index=0&id=08cda4fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cda4fc",
  null
  
)

export default component.exports